export default "__VITE_ASSET__Bz_wsUGV__"